import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission, FilterState } from '@np/np_webcomponentlib'
import { API_BUSINESS } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsIdrfspecification, columnsIdrfcharacteristictype } from './ProductProviderTypes'

// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'


export const ProductProviderForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {



    const initialFilterState: FilterState = {
        listFields: [{ fieldName: "typeBusiness", comparison: "equalsStrong", listVal: ["provider"] }],
        sort: null,
        searchData: '',
        take: 50,
        skip: 0,
      };

      
    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_BUSINESS}rgproductprovider/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    const [, doFetchCreateUpdate] = useFetch(
        `${API_BUSINESS}rgproductprovider`)//{ error: errCU, isLoading: isLoadCU, response: respCU }

    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })

    }


    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('product')}</Form.Label>
                <Col md={9}>


                    <ChooseComponent
                        getDisplayDescription={(seletedData: any) => {
                            return seletedData ? seletedData.name : 'Выберите...'
                        }}
                        apiUrl={`${API_BUSINESS}business/list`}
                        columns={columnsIdrfspecification}
                        selectData={(selectData: any) => {
                            setEntity((prev) => { return { ...prev, idrfBusinessAsProduct: selectData.idUnique } })
                        }}
                        resetData={() => {
                            setEntity((prev) => { return { ...prev, idrfBusinessAsProduct: "" } })
                        }}
                        initIDUnique={entity.idrfBusinessAsProduct !== null ? entity.idrfBusinessAsProduct : ""}
                    >
                        Выберите продукт
                    </ChooseComponent>
                </Col>
            </Row>
            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('provider')}</Form.Label>
                <Col md={9}>
                    <ChooseComponent
                        getDisplayDescription={(seletedData: any) => {
                            return seletedData ? seletedData.name : 'Выберите...'
                        }}
                        apiUrl={`${API_BUSINESS}business/list`}
                        columns={columnsIdrfcharacteristictype}
                        selectData={(selectData: any) => {
                            setEntity((prev) => { return { ...prev, idrfBusinessAsProvider: selectData.idUnique } })
                        }}
                        resetData={() => {
                            setEntity((prev) => { return { ...prev, idrfBusinessAsProvider: "" } })
                        }}
                        initIDUnique={entity.idrfBusinessAsProvider !== null ? entity.idrfBusinessAsProvider : ""}
                        initialFilterState = {initialFilterState}
                    >
                        Выберите провайдера
                    </ChooseComponent>
                </Col>
            </Row>
            


            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>
            {/* </Form> */}
        </Card.Body>
    </Card>)
}
